import axios from "axios";
import { api } from "./api_route";

export const searchCaseDocuments = async (payload) => {
  try {
    const response = await axios.post(
      `${api}/caseDocuments/searchCaseDocuments`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("searchCaseDocuments API error:", error);
    throw error.response?.data || error;
  }
};